module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }